const STATUSES = {
  created: {
    order: 1,
    name: "criada",
    icon: "done",
    color: "blue",
    description: "A conta foi criada.",
    event: "criada"
  },
  waiting_email_verification: {
    order: 2,
    name: "esperando verificação de email",
    icon: "hourglass_empty",
    color: "orange",
    description: "O email de verificação foi enviado.",
    event: "Esperando verificação Email"
  },
  email_verified: {
    order: 3,
    name: "email verificado",
    icon: "mail_outline",
    color: "primary",
    description: "O email foi verificado.",
    event: "Email verificado"
  },
  active: {
    order: 4,
    name: "ativa",
    icon: "done_all",
    color: "success",
    description: "As dependências (PGA e PGC) foram criadas no Wirecard.",
    event: "Ativada"
  },
  inactive: {
    order: 5,
    name: "inativa",
    icon: "remove_circle_outline",
    color: "warning",
    description: "A conta foi inativada por um administrador.",
    event: "Inativada"
  },
  blocked: {
    order: 6,
    name: "bloqueada",
    icon: "block",
    color: "accent",
    description: "A conta foi bloqueada por um administrador.",
    event: "Bloqueada"
  }
};

function getStatus(status) {
  return STATUSES[status];
}

function getStatuses() {
  let statuses = Object.keys(STATUSES);
  let results = [];
  statuses.map(status => results.push(STATUSES[status]));
  return results;
}

const validFirstName = account => account.first_name != undefined;
const validLastName = account => account.last_name != undefined;
const validFullName = account =>
  validFirstName(account) && validLastName(account);

const fullName = account => {
  if (!validFullName(account)) return "";
  let fullname = `${account.first_name.toLowerCase()} ${account.last_name.toLowerCase()}`;
  return fullname.replace(/(^\w{1})|(\s{1}\w{1})/g, match =>
    match.toUpperCase()
  );
};

export default {
  filters: {
    fullName,
    getAccountStatus(status, field = "name") {
      return STATUSES[status] ? STATUSES[status][field] : "";
    }
  },
  methods: {
    fullName,
    getStatus,
    getStatuses
  }
};



// WEBPACK FOOTER //
// ./src/mixins/accountMixin.js